import React from "react";

const FooterLogo = () => {
  return (
    <div className="logo logo-secondary">
      <img src="assets/img/logo/logo-light.png" alt="Logo" />
    </div>
  );
};

export default FooterLogo;
